import { Medicine } from "@interfaces/Search";

export const formatMedicineToSearch = (medicine: Medicine) => {
  if (medicine.type === "GENERIC") {
    return `${medicine.activePrinciple} · ${medicine.concentration} · ${medicine.format}`;
  }
  let search = medicine.activePrinciple ?? medicine.name;
  if (medicine.concentration)
    search = search.concat(` · ${medicine.concentration}`);
  if (medicine.format) search = search.concat(` · ${medicine.format}`);
  return search;
};
